/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect} from 'react';
import useActions from 'hooks/useActions';
import InformationTab from 'components/InformationTab';
import SingleFilter from 'components/SingleFilter';
import FlagsTable from './FlagsTable';
import TableNavigator from 'components/TableNavigator';
import TableResults from 'components/TableResults';
import { useParams } from 'react-router-dom';
import {SORTING_OPTIONS,STATUS_OPTIONS} from 'constants/COMMUNITY_STATUS';


const { connect } = require('react-redux');

function mapStateToProps(state) {
    return {
        flags: state.CsArticles.flagsSelectedArticle,
        isLoading: state.CsArticles.isLoadingFlags,
        per_page: state.CsArticles.flagsPerPage,
        page: state.CsArticles.flagsPage,
        total: state.CsArticles.flagsTotal,
        total_pages: state.CsArticles.flagsTotalPages,
        sortingFilter: state.CsArticles.flagsOrder,
        statusFilter: state.CsArticles.flagsStatus,
    };
}

const ArticleFlags = connect(mapStateToProps)(function (props) {
    const {
        flags,
        isLoading,
        per_page,
        page,
        total,
        total_pages,
        sortingFilter,
        statusFilter,
    } = props;
    const {
        CS_FETCH_ARTICLE_FLAGS_REQUEST,
        CS_SELECT_ARTICLE_FLAGS_ORDER_FILTER,
        CS_SELECT_ARTICLE_FLAGS_STATUS_FILTER
    } = useActions();

    const { id } = useParams();

    useEffect(() => {
        CS_FETCH_ARTICLE_FLAGS_REQUEST({
            articleId: id,
            page,
            per_page,
            sorting: sortingFilter,
            status: statusFilter,
        });
    }, []);

    useEffect(() => {
        CS_FETCH_ARTICLE_FLAGS_REQUEST({
            articleId: id,
            page,
            per_page,
            sorting: sortingFilter,
            status: statusFilter,
        });
    }, [sortingFilter,statusFilter]);

    function filters() {
        return [
            <SingleFilter
                options={[
                    { value: 'all', label: 'All Statuses'},
                    ...STATUS_OPTIONS,
                ]}
                selectedValue={statusFilter}
                onSelect={(value) =>
                    CS_SELECT_ARTICLE_FLAGS_STATUS_FILTER(value)
                }
            />,
            <SingleFilter
                options={[
                    ...SORTING_OPTIONS,
                ]}
                selectedValue={sortingFilter}
                onSelect={(value) =>
                    CS_SELECT_ARTICLE_FLAGS_ORDER_FILTER(value)
                }
            />,
        ]
    }

    const onNextPage = () => {
        CS_FETCH_ARTICLE_FLAGS_REQUEST({
            articleId: id,
            per_page,
            page: page + 1,
            sorting: sortingFilter,
            status: statusFilter,
        });
    }

    const onPrevPage = () => {
        CS_FETCH_ARTICLE_FLAGS_REQUEST({
            articleId: id,
            per_page,
            page: page - 1,
            sorting: sortingFilter,
            status: statusFilter,
        });
    }
    const onPageSelect = (pageSelected) => {
        CS_FETCH_ARTICLE_FLAGS_REQUEST({
            articleId: id,
            per_page,
            page: pageSelected,
            sorting: sortingFilter,
            status: statusFilter,
        });
    }

    const onPerPageSelected = ({ perPage }) => {
        CS_FETCH_ARTICLE_FLAGS_REQUEST({
            articleId: id,
            per_page: perPage,
            page: page,
            sorting: sortingFilter,
            status: statusFilter,
        });
    }

    return (
        <section>
            <InformationTab
                sectionName="Flags"
                customFilters={filters()}
                dataTable={
                    <div>
                        <TableResults results={total} />
                        <FlagsTable
                            flags={flags}
                            isLoading={isLoading}
                        />
                        <TableNavigator
                            currentPage={page}
                            totalPages={total_pages}
                            onNext={onNextPage}
                            onPrev={onPrevPage}
                            onPageSelected={onPageSelect}
                        />
                    </div>
                }
                showPrograms={false}
                perPage={per_page}
                onPerPageSelected={onPerPageSelected}
                showBreadcrumbs={false}
            />
        </section>
    );
});

export default ArticleFlags;
